import React, { useState } from 'react'
import styled from 'styled-components'
import { formatCurrency } from '../../../helpers/currency.format.helper'
import { ButtonBlue } from '../../common/ButtonsGenerics'
import { createRefundFromPendingResquests } from '../../../redux/api/account'

const RefundPayment = ({ amount, gotoPage, selectedRequestIds = [] }) => {
    const [refundResponse, setRefundResponse] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const selectedRequestsCount = selectedRequestIds.length
    const message = selectedRequestsCount === 1
        ? 'El importe de solicitud generará un reintegro'
        : 'Las solicitudes elegidas se cancelarán con el saldo a favor y se generará un reintegro por la diferencia'

    const handleGenerarReintegro = async () => {
        if (isSubmitting) return

        setIsSubmitting(true)
        try {
            const response = await createRefundFromPendingResquests({
                pagoSolicitudIdArr: selectedRequestIds
            })
            setRefundResponse(!response.error)
        } catch (error) {
            setRefundResponse(false)
        } finally {
            setIsSubmitting(false)
        }
    }

    const handleCerrar = () => {
        gotoPage(null)
    }

    return (
        <Container>
            <Message>{message}</Message>
            <Amount>Diferencia a reintegrar: ${formatCurrency(Math.abs(Number(amount)).toFixed(2))}</Amount>
            {refundResponse !== null && <ResultMessage success={refundResponse}>
                {refundResponse
                    ? 'El reintegro se ha creado con éxito'
                    : 'El reintegro no ha sido generado'}
            </ResultMessage>}
            {refundResponse !== null
                ? <ButtonBlue onClick={handleCerrar}>Cerrar</ButtonBlue>
                : <ButtonBlue disabled={isSubmitting} onClick={handleGenerarReintegro}>Aceptar</ButtonBlue>}
        </Container>
    )
}

export default RefundPayment

const Container = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 12px;
    margin: 18px 0;
`

const Message = styled.div`
    font-size: 18px;
    font-weight: bold;
`

const Amount = styled.div`
    font-size: 18px;
`

const ResultMessage = styled.div`
    font-size: 18px;
    font-weight: bold;
    color: ${({ success }) => success ? '#4caf50' : '#e34d4b'};
`
